<template>
    <section>
        <div class="row">
            <div class="col-md-8">
                <filterable @loading="changeLoading" ref="filter" v-bind="filterable">
                    <thead slot="thead">
                        <tr>
                            <th>Nome do Grupo</th>
                            <th>Signatários</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tr slot-scope="{item}">
                        <td @click="changeSelected(item)">
                            <p-radio :value="item" :checked="selected == item" name="groupSelected" :color="appLayout.check">{{item.nome}}</p-radio>
                        </td>
                        <td @click="changeSelected(item)">{{ item.signatarios.map(a => a.assinatura_nome)}}</td>
                        <td class="text-center"><button @click="edit(item)" class="btn-sm btn btn-outline-secondary"><i
                                    class="fa fa-edit"></i></button></td>
                        <td class="text-center"><button @click="destroy(item)" class="btn-sm btn btn-outline-danger"><i
                                    class="fa fa-trash"></i></button></td>
                    </tr>
                </filterable>
            </div>
            <div class="col-md-4">
                <div class="row">
                    <div class="col-md-12">
                        <div class="callout callout-info">
                            <h6><b><i class="fa fa-users"></i></b>
                                Escolha abaixo o tipo de assinatura e tipo de Autenticação para ser adicionado ao grupo,
                                ao clicar em adicionar será adiciionado todos os signatários do grupo ao(s) arquivo(s)
                            </h6>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label><i class="fa fa-pencil"></i> Tipo de assinatura</label>
                            <select :class="{'is-invalid':errors.has('tipo')}" v-validate="{required:true}"
                                v-model="request.assinatura_tipo" class="form-control" name="tipo">
                                <option value="1">Assinar</option>
                                <option value="2">Aprovar</option>
                                <option value="3">Reconhecer</option>
                                <option value="4">Assinar como parte</option>
                                <option value="5">Assinar como testemunha</option>
                                <option value="6">Assinar como interveniente</option>
                                <option value="7">Acusar recebimento</option>
                                <option value="8">Dar ciência</option>
                            </select>
                            <div class="invalid-feedback help-block error">{{errors.first('tipo')}}</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label><i class="fa fa-shield"></i> Autenticação por Token</label>
                            <select :class="{'is-invalid':errors.has('autenticacao')}" v-validate="{required:true}"
                                v-model="request.token_tipo" class="form-control" name="autenticacao">
                                <option value="E">E-mail</option>
                                <option value="M">Celular</option>
                            </select>
                            <div class="invalid-feedback help-block error">{{errors.first('autenticacao')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            grupos: []
        },
        data() {
            return {
                filterable: {
                    disableAutoGet: true,
                    deleted: false,
                    storeAction: 'setGrupoSignatarios',
                    storeName: 'grupoSignatarios.data',
                    model: 'grupoSignatarios',
                    url: '/api/grupo-signatarios',
                },
                selected: null,
                request: {
                    token_tipo: 'E',
                    assinatura_tipo: '1',
                    grupo: null,
                }
            }
        },
        methods: {
            fetchData() {
                this.$refs.filter.fetch();
            },
            edit(payload) {
                this.$emit('edit', payload);
            },
            destroy(payload) {
                this.$emit('destroy', payload);
            },
            changeSelected(payload) {
                this.request.grupo = payload;
                this.selected = payload;
                this.$emit('changeSelected', this.request);
            }
        }
    }
</script>